import { render, staticRenderFns } from "./startQuestion.vue?vue&type=template&id=f163ead6&scoped=true&"
import script from "./startQuestion.vue?vue&type=script&lang=js&"
export * from "./startQuestion.vue?vue&type=script&lang=js&"
import style0 from "./startQuestion.vue?vue&type=style&index=0&id=f163ead6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f163ead6",
  null
  
)

export default component.exports